import { render, staticRenderFns } from "./TotalPanel.vue?vue&type=template&id=1a49898e&scoped=true&"
import script from "./TotalPanel.vue?vue&type=script&lang=js&"
export * from "./TotalPanel.vue?vue&type=script&lang=js&"
import style0 from "./TotalPanel.vue?vue&type=style&index=0&id=1a49898e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49898e",
  null
  
)

export default component.exports